<h5>{{ 'STEP3.question' | translate  }}</h5>
<app-numeric-up-down [(value)]="quotation.cashRegisters"></app-numeric-up-down>
<i class="question" [innerHTML]="'STEP3.description' | translate"></i>
